<template>
  <div class="p-tasklist-proposals l-block">
    <div class="p-tasklist-proposals__header">
      <div class="c-image--radius l-mr-2">
        <img src="@/assets/img/img-chara-task.svg" alt="" width="50" />
      </div>
      <h2 class="p-tasklist-proposals__title">
        SEARCH WRITEからの改善提案リスト
      </h2>
    </div>
    <div class="p-tasklist-proposals__content">
      <div class="p-tasklist-proposal">
        <div class="p-tasklist-proposal__header">
          <h3 class="p-tasklist-proposal__title">タイトル変更の提案</h3>
          <p>
            順位が高く、表示回数が多い割に、クリック率が少ないワードへの改善提案です。
          </p>
        </div>
        <ListProposal :project="project" type="changeTd" />
      </div>
      <div class="p-tasklist-proposal">
        <div class="p-tasklist-proposal__header">
          <h3 class="p-tasklist-proposal__title">
            コンテンツのリライト（加筆・修正）の提案
          </h3>
          <p>
            検索ボリュームが多く、惜しい順位（6位～50位）のキーワードへの改善提案です。
          </p>
        </div>
        <ListProposal :project="project" type="rewrite" />
      </div>
      <div class="p-tasklist-proposal">
        <div class="p-tasklist-proposal__header">
          <h3 class="p-tasklist-proposal__title">
            新規コンテンツの提案
          </h3>
          <p>
            新規キーワード発見から発見したキーワードを用いた新規コンテンツの作成提案です。
            <br />
            ※ 順位が圏外の場合はURLとタイトルは「-」で表示
          </p>
        </div>
        <ListProposal :project="project" type="createContent" />
      </div>
    </div>
  </div>
</template>

<script>
import ListProposal from '@/components/taskList/ListProposal';

export default {
  props: {
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    ListProposal
  }
};
</script>
